{
  "internalPortal": {
    "components": {
      "tabs": {
        "onlineAccess": "Online Access"
      },
      "onlineAccess": {
        "title": "AP Systems / Online Access",
        "subtitle": "Access AP System records available for this organization",
        "actions": {
          "openLink": "Open link",
          "copyTooltip": "Password will be copied to the clipboard",
          "viewAll": "view all"
        },
        "filters": {
          "archived": "Archived"
        },
        "status": {
          "archived": "Archived"
        },
        "fields": {
          "status": "Status",
          "website": "Website",
          "vendors": "Vendors",
          "username": "Username",
          "password": "Password",
          "note": "Note",
          "name": "AP System / Vendor name",
          "vendor": "Vendor",
          "vendorAccounts": "Vendor Accounts"
        },
        "form": {
          "createTitle": "New AP Systems / Online Access",
          "editTitle": "Edit AP Systems / Online Access",
          "passwordDisabledMissingCredentialsTooltip": "You do not have permission to set a password. Credentials access is required.",
          "placeholders": {
            "name": "Subject",
            "note": "Note",
            "website": "Website URL",
            "vendor": "Vendor Name",
            "username": "Username",
            "password": "Password"
          },
          "create": {
            "success": "Online access record created successfully",
            "error": "Failed to create online access record"
          },
          "edit": {
            "success": "Online access record updated successfully",
            "error": "Failed to update online access record"
          }
        },
        "deleteDialog": {
          "title": "Delete online access record?",
          "description": "Are you sure you want to delete \"{{name}}\"? This action cannot be undone."
        },
        "deleteError": "Failed to delete online access record",
        "copyError": "Failed to copy credential",
        "noData": {
          "title": "No online access records found",
          "description": "There are no AP system / online access records for this organization yet."
        }
      }
    }
  }
}
